import { render } from "./Wechat.vue?vue&type=template&id=427b1d1e"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/Wechat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "427b1d1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('427b1d1e', __exports__)) {
    api.reload('427b1d1e', __exports__)
  }
  
  module.hot.accept("./Wechat.vue?vue&type=template&id=427b1d1e", () => {
    api.rerender('427b1d1e', render)
  })

}


export default __exports__